export let RoundingStrategy;
(function (RoundingStrategy) {
  RoundingStrategy["up"] = "up";
  RoundingStrategy["down"] = "down";
  RoundingStrategy["default"] = "default";
})(RoundingStrategy || (RoundingStrategy = {}));
//# sourceMappingURL=types.js.map